// src/components/IOSAppBanner.tsx
import React, { useState, useEffect } from 'react';
import { Flex, Button, Text } from '@aws-amplify/ui-react';
import { X, Download, Smartphone } from 'lucide-react';
import './IOSAppBanner.css';

const IOSAppBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Check if user has dismissed the banner before
    const dismissed = localStorage.getItem('ios-banner-dismissed');
    if (dismissed) {
      setIsDismissed(true);
      return;
    }

    // Check if user is on iOS device (optional - show to all users for now)
    // const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    
    // Show banner after a short delay for better UX
    const timer = setTimeout(() => {
      setIsVisible(true);
      // Add class to body to adjust layout
      document.body.classList.add('ios-banner-active');
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    setIsDismissed(true);
    localStorage.setItem('ios-banner-dismissed', 'true');
    // Remove class from body
    document.body.classList.remove('ios-banner-active');
  };

  const handleDownload = () => {
    window.open('https://apps.apple.com/il/app/banjara-app/id6744937639', '_blank');
    // Optionally dismiss after download click
    handleDismiss();
  };

  if (isDismissed || !isVisible) {
    return null;
  }

  return (
    <div className={`ios-banner ${isVisible ? 'ios-banner-visible' : ''}`}>
      <Flex
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        padding="0.75rem 1rem"
        className="ios-banner-content"
      >
        {/* Left side - Icon and text */}
        <Flex direction="row" alignItems="center" gap="0.75rem" className="ios-banner-info">
          <div className="ios-banner-icon">
            <Smartphone size={20} />
          </div>
          <Flex direction="column" gap="0.125rem">
            <Text className="ios-banner-title">
              Get the Banjara App
            </Text>
            <Text className="ios-banner-subtitle">
              Download for iOS • Android coming soon
            </Text>
          </Flex>
        </Flex>

        {/* Right side - Actions */}
        <Flex direction="row" alignItems="center" gap="0.5rem">
          <Button
            onClick={handleDownload}
            className="ios-banner-download-btn"
            size="small"
          >
            <Download size={16} />
            <span className="ios-banner-btn-text">Download</span>
          </Button>
          <Button
            onClick={handleDismiss}
            className="ios-banner-close-btn"
            size="small"
            variation="link"
          >
            <X size={18} />
          </Button>
        </Flex>
      </Flex>
    </div>
  );
};

export default IOSAppBanner;